import { Component, ChangeDetectionStrategy, Input } from "@angular/core";
import { AppDefinitions } from "app/shared";
import { DefinitionKey } from "app/shared/services";

@Component({
    selector: "app-definition-tag",
    template: `
        <span class="definition-tag" [class.definition-tag--condensed]="condensed">
            {{ text || _definitions.getDisplayName(definitionKey, code) }}
        </span>
    `,
    styleUrls: ["./definition-tag.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DefinitionTagComponent {
    @Input() text: string;
    @Input() definitionKey: DefinitionKey;
    @Input() code: string;
    @Input() condensed: boolean;

    constructor(public _definitions: AppDefinitions) {}
}
